import ReportService from '../services/report.service';
import { Region } from './models/models';

export default {
  namespaced: true,
  state: {
    filters: {
      type: null,
      dateFrom: null,
      dateTo: null,
      dateType: null,
      axisX: null,
      axisY: null,
    },
  },
  mutations: {
    filterProps(state, props) {
      state.filters = Object.assign({}, state.filters, props);
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('getRegions');
    },
    getReports({ state }) {
      return ReportService.getReport(state.filters);
    },
  },
  getters: {
    regions() {
      return Region.all();
    },
  },
};
